exports.ByName = {
  DoesNotHaveWarning: { Id: 0, Name: 'DoesNotHaveWarning' },
  HasWarning: { Id: 1, Name: 'HasWarning' }
};

exports.ById = {
  0: { Id: 0, Name: 'DoesNotHaveWarning' },
  1: { Id: 1, Name: 'HasWarning' }
};
